const { name } = require('../helpers/env.js');

// @todo can we test for these?

module.exports = () => ['Firefox', 'Safari', 'Edge', 'Chrome', 'Opera'].indexOf(name) > -1;
